// Inline SVG icons (24 × 24, 2 px strokes) drawn for TrailBivvy — the web stand-in for the SF Symbols of the iOS app.
// `iconForSymbol` maps the SF Symbol names kept by src/ui/presentation to these icons.

const paths = {
  map: 'M3 6l6-3 6 3 6-3v15l-6 3-6-3-6 3z M9 3v15 M15 6v15',
  route: 'M5 19c5 0 4-7 7-7s2-7 7-7 M5 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4z M19 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4z',
  moon: 'M20 13.5A8.5 8.5 0 1 1 10.5 4a6.5 6.5 0 0 0 9.5 9.5z',
  hiker: 'M13 5.5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5z M12 8l-2 6 3 3 1 5 M10 14l-3 2 M12 9l3 3 2.5-1 M9 21.5l2-5 M18 9v13',
  more: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z M7.5 12h.01 M12 12h.01 M16.5 12h.01',
  safety: 'M12 2.5l8 3v6c0 5-3.4 8.7-8 10.5-4.6-1.8-8-5.5-8-10.5v-6z M12 8v7 M8.5 11.5h7',
  location: 'M3 11l18-8-8 18-2-8z',
  layers: 'M12 3l9 5-9 5-9-5z M3 13l9 5 9-5',
  search: 'M10.5 17.5a7 7 0 1 0 0-14 7 7 0 0 0 0 14z M21 21l-5.5-5.5',
  filter: 'M3 6h18 M6 12h12 M10 18h4',
  download: 'M12 3v12 M7 10l5 5 5-5 M4 20h16',
  upload: 'M12 15V3 M7 8l5-5 5 5 M4 20h16',
  check: 'M5 12.5l4.5 4.5L19 7',
  checkCircle: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z M8 12.5l3 3 5-6',
  x: 'M6 6l12 12 M18 6L6 18',
  xCircle: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z M9 9l6 6 M15 9l-6 6',
  chevronRight: 'M9 5l7 7-7 7',
  chevronLeft: 'M15 5l-7 7 7 7',
  chevronDown: 'M5 9l7 7 7-7',
  info: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z M12 11v6 M12 7.5v.01',
  warning: 'M12 3.5L22 20H2z M12 10v5 M12 17.5v.01',
  caution: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z M12 7v6 M12 16.5v.01',
  prohibited: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z M5.6 5.6l12.8 12.8',
  question: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.7.3-1 .9-1 1.7v.5 M12 17v.01',
  drop: 'M12 3c4 5 6.5 8.2 6.5 11.5a6.5 6.5 0 0 1-13 0C5.5 11.2 8 8 12 3z',
  tent: 'M2 20h20 M12 4L3.5 20 M12 4l8.5 16 M12 12.5L9 20 M12 12.5l3 7.5',
  hut: 'M3 11l9-7 9 7 M5 9.5V20h14V9.5 M10 20v-6h4v6',
  bed: 'M3 18V6 M3 14h18v4 M21 14v-2a3 3 0 0 0-3-3h-7v5 M7 12a1.6 1.6 0 1 0 0-3.2A1.6 1.6 0 0 0 7 12z',
  shelter: 'M3 12l9-8 9 8 M6 10v10 M18 10v10 M3 20h18',
  village: 'M3 20V11l5-4 5 4v9 M13 20v-6h8v6 M6 20v-4h4v4 M3 20h18',
  bus: 'M6 3h12a2 2 0 0 1 2 2v12H4V5a2 2 0 0 1 2-2z M4 11h16 M7 17v3 M17 17v3 M7.5 14h.01 M16.5 14h.01',
  train: 'M7 3h10a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3z M4 11h16 M8 21l2-3 M16 21l-2-3 M8 15h.01 M16 15h.01',
  cablecar: 'M3 4l18 4 M12 6v4 M6 10h12l1 9H5z M5 15h14',
  phone: 'M5 3h4l2 5-2.5 1.5a11 11 0 0 0 6 6L16 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 5a2 2 0 0 1 2-2z',
  share: 'M12 15V3 M8 7l4-4 4 4 M5 11v9h14v-9',
  copy: 'M9 9h11v11H9z M5 15H4V4h11v1',
  play: 'M7 4l13 8-13 8z',
  pause: 'M7 4h3.5v16H7z M13.5 4H17v16h-3.5z',
  stop: 'M6 6h12v12H6z',
  record: 'M12 19a7 7 0 1 0 0-14 7 7 0 0 0 0 14z',
  plus: 'M12 5v14 M5 12h14',
  minus: 'M5 12h14',
  trash: 'M4 7h16 M9 7V4h6v3 M6 7l1 13h10l1-13 M10 11v6 M14 11v6',
  gear: 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z M12 2v3 M12 19v3 M2 12h3 M19 12h3 M4.9 4.9L7 7 M17 17l2.1 2.1 M4.9 19.1L7 17 M17 7l2.1-2.1',
  star: 'M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1-4.4-4.3 6.1-.9z',
  sun: 'M12 16.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9z M12 2v2 M12 20v2 M2 12h2 M20 12h2 M4.9 4.9l1.4 1.4 M17.7 17.7l1.4 1.4 M4.9 19.1l1.4-1.4 M17.7 6.3l1.4-1.4',
  sunset: 'M3 18h18 M7 18a5 5 0 0 1 10 0 M12 3v6 M9 6l3 3 3-3 M5 21h14',
  cloud: 'M7 18.5a4.5 4.5 0 1 1 .9-8.9A6 6 0 0 1 19.4 11 3.8 3.8 0 0 1 18 18.5z',
  rain: 'M7 14.5a4.5 4.5 0 1 1 .9-8.9A6 6 0 0 1 19.4 7 3.8 3.8 0 0 1 18 14.5z M8 18l-1 3 M12 18l-1 3 M16 18l-1 3',
  thunder: 'M7 14.5a4.5 4.5 0 1 1 .9-8.9A6 6 0 0 1 19.4 7 3.8 3.8 0 0 1 18 14.5z M13 13l-3 4h4l-3 4',
  snow: 'M12 2v20 M3.3 7l17.4 10 M3.3 17L20.7 7 M9 4l3 2 3-2 M9 20l3-2 3 2',
  fog: 'M4 8h16 M2 12h20 M4 16h16 M7 20h10',
  wind: 'M3 8h11a3 3 0 1 0-3-3 M3 12h16a3 3 0 1 1-3 3 M3 16h8',
  thermometer: 'M14 14.8V4a2 2 0 0 0-4 0v10.8a4 4 0 1 0 4 0z M12 18v.01',
  mountain: 'M2 20l7-12 4 6 3-4 6 10z',
  flag: 'M5 21V4 M5 4h12l-2.5 4.5L17 13H5',
  compass: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z M15.5 8.5l-2 5-5 2 2-5z',
  lock: 'M6 11h12v10H6z M8.5 11V7.5a3.5 3.5 0 0 1 7 0V11',
  mail: 'M3 6h18v12H3z M3 7l9 6 9-6',
  key: 'M8 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M12 11h9 M18 11v3 M21 11v2',
  external: 'M14 4h6v6 M20 4l-9 9 M18 14v6H4V6h6',
  refresh: 'M20 11a8 8 0 1 0-2.3 5.7 M20 4v7h-7',
  clock: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z M12 7v5l3 2',
  calendar: 'M4 5h16v16H4z M4 10h16 M8 3v4 M16 3v4',
  card: 'M3 6h18v12H3z M3 10h18 M7 15h4',
  doc: 'M6 3h9l4 4v14H6z M15 3v4h4 M9 12h6 M9 16h6',
  shield: 'M12 2.5l8 3v6c0 5-3.4 8.7-8 10.5-4.6-1.8-8-5.5-8-10.5v-6z M8.5 12l2.5 2.5 4.5-5',
  globe: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z M3 12h18 M12 3c2.5 2.5 3.5 5.5 3.5 9s-1 6.5-3.5 9 M12 3c-2.5 2.5-3.5 5.5-3.5 9s1 6.5 3.5 9',
  ruler: 'M3 8h18v8H3z M7 8v3 M11 8v4 M15 8v3 M19 8v4',
  battery: 'M3 8h15v8H3z M20 11v2 M5 10h6v4H5z',
  offline: 'M2 2l20 20 M8.5 16.5a5 5 0 0 1 7 0 M5 13a10 10 0 0 1 5.2-2.8 M19 13a10 10 0 0 0-2.3-1.7 M2 9.5a15 15 0 0 1 4.6-2.9 M22 9.5A15 15 0 0 0 10.7 5 M12 20v.01',
  wifi: 'M8.5 16.5a5 5 0 0 1 7 0 M5 13a10 10 0 0 1 14 0 M2 9.5a15 15 0 0 1 20 0 M12 20v.01',
  eye: 'M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
  eyeOff: 'M3 3l18 18 M10.6 5.1A10 10 0 0 1 12 5c6.5 0 10 7 10 7a17 17 0 0 1-3.2 4.2 M6.6 6.6A17 17 0 0 0 2 12s3.5 7 10 7a9.6 9.6 0 0 0 5.4-1.6 M9.9 9.9a3 3 0 0 0 4.2 4.2',
  leaf: 'M5 21c0-9 5-15 15-16-1 10-7 15-15 16z M5 21l8-8',
  directions: 'M4 20v-6a4 4 0 0 1 4-4h12 M16 6l4 4-4 4',
  car: 'M3 16v-4l2.5-5h13L21 12v4z M3 12h18 M7 19.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z M17 19.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z',
  parking: 'M4 3h16v18H4z M10 17V7h3a3 3 0 0 1 0 6h-3',
  chart: 'M3 20l5-8 4 4 4-7 5 11z',
  list: 'M8 6h13 M8 12h13 M8 18h13 M3.5 6h.01 M3.5 12h.01 M3.5 18h.01',
  photo: 'M3 5h18v14H3z M3 16l5-5 4 4 3-3 6 6 M15.5 9.5a1.5 1.5 0 1 0 0-.01',
  pin: 'M12 22s7-6.5 7-12a7 7 0 1 0-14 0c0 5.5 7 12 7 12z M12 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z',
  target: 'M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16z M12 2v4 M12 18v4 M2 12h4 M18 12h4 M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2z',
  food: 'M7 3v8 M4 3v5a3 3 0 0 0 6 0V3 M7 11v10 M17 21V3c-2 1-3 4-3 8h3',
  shop: 'M5 8h14l-1 13H6z M9 8V6a3 3 0 0 1 6 0v2',
  health: 'M4 6h16v14H4z M9 6V4h6v2 M12 10v6 M9 13h6',
  water: 'M12 3c4 5 6.5 8.2 6.5 11.5a6.5 6.5 0 0 1-13 0C5.5 11.2 8 8 12 3z M9 15a3 3 0 0 0 3 3',
  flame: 'M12 22a7 7 0 0 0 7-7c0-4-3-6-4-10-2 2-3 4-3 6-1-1-2-2-2-4-3 3-5 5-5 8a7 7 0 0 0 7 7z',
  tree: 'M12 3l6 9h-3l4 6H5l4-6H6z M12 18v3',
  person: 'M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M4 21a8 8 0 0 1 16 0',
  sparkle: 'M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z',
  circle: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z',
  hand: 'M7 11V5a1.5 1.5 0 0 1 3 0v6 M10 10V3.5a1.5 1.5 0 0 1 3 0V10 M13 10V4.5a1.5 1.5 0 0 1 3 0V11 M16 11V7.5a1.5 1.5 0 0 1 3 0V14a8 8 0 0 1-8 8h-1a7 7 0 0 1-5.6-2.8L2 15.5a1.6 1.6 0 0 1 2.4-2L7 15V11',
  binoculars: 'M6.5 20a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z M17.5 20a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z M10 16.5h4 M3 16.5L5 6h4l1 7 M21 16.5L19 6h-4l-1 7',
} as const;

export type IconName = keyof typeof paths;

const filled = new Set<IconName>(['play', 'record', 'stop', 'pause']);

export function Icon({ name, label, class: className }: { name: IconName; label?: string; class?: string }) {
  const isFilled = filled.has(name);
  return (
    <svg
      viewBox="0 0 24 24"
      fill={isFilled ? 'currentColor' : 'none'}
      stroke="currentColor"
      stroke-width={isFilled ? 0 : 2}
      stroke-linecap="round"
      stroke-linejoin="round"
      class={className}
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      focusable="false"
    >
      <path d={paths[name]} />
    </svg>
  );
}

const symbolRules: Array<[RegExp, IconName]> = [
  [/^cross\.case|pills|stethoscope|medical/, 'health'],
  [/cross|staroflife|sos/, 'safety'],
  [/exclamationmark\.triangle/, 'warning'],
  [/exclamationmark/, 'caution'],
  [/checkmark\.shield|shield/, 'shield'],
  [/checkmark/, 'checkCircle'],
  [/nosign|minus\.circle|hand\.raised/, 'prohibited'],
  [/xmark/, 'xCircle'],
  [/questionmark/, 'question'],
  [/info/, 'info'],
  [/cloud\.bolt|bolt/, 'thunder'],
  [/cloud\.(rain|drizzle|heavyrain|sleet)/, 'rain'],
  [/snow/, 'snow'],
  [/fog/, 'fog'],
  [/cloud/, 'cloud'],
  [/sunset|sunrise/, 'sunset'],
  [/sun/, 'sun'],
  [/moon/, 'moon'],
  [/wind/, 'wind'],
  [/thermometer/, 'thermometer'],
  [/drop|water/, 'drop'],
  [/tent/, 'tent'],
  [/bed/, 'bed'],
  [/house\.lodge|house/, 'hut'],
  [/building/, 'village'],
  [/bus/, 'bus'],
  [/tram|train/, 'train'],
  [/cablecar|gondola/, 'cablecar'],
  [/parkingsign|parking/, 'parking'],
  [/car/, 'car'],
  [/phone/, 'phone'],
  [/fork\.knife|cup/, 'food'],
  [/cart|bag|basket/, 'shop'],
  [/mountain|triangle/, 'mountain'],
  [/leaf/, 'leaf'],
  [/tree/, 'tree'],
  [/flame|fire/, 'flame'],
  [/figure|walk|hiking/, 'hiker'],
  [/mappin|pin/, 'pin'],
  [/map/, 'map'],
  [/location|scope/, 'location'],
  [/flag/, 'flag'],
  [/clock|timer|hourglass/, 'clock'],
  [/calendar/, 'calendar'],
  [/lock/, 'lock'],
  [/eye\.slash/, 'eyeOff'],
  [/eye|binoculars/, 'binoculars'],
  [/arrow\.triangle|arrow\.turn/, 'directions'],
  [/star/, 'star'],
  [/chart|waveform/, 'chart'],
  [/doc|text/, 'doc'],
  [/globe/, 'globe'],
  [/person/, 'person'],
  [/wifi\.slash|antenna/, 'offline'],
  [/sparkle/, 'sparkle'],
];

/** Maps an SF Symbol name (as kept by src/ui/presentation) to the closest icon here. */
export function iconForSymbol(symbol: string | undefined): IconName {
  if (!symbol) return 'circle';
  if (symbol in paths) return symbol as IconName;
  for (const [pattern, icon] of symbolRules) if (pattern.test(symbol)) return icon;
  return 'circle';
}
